import { z } from 'zod';
import { baseTaskSchema } from '../schema.base.js';
import { hyphenatableWordInput } from './input.hyphenatable-word.js';

const selectAnswersHyphenateWordsTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("SelectAnswers"),
  answerType: z.literal("HyphenateWords"),
  contents: z.array(hyphenatableWordInput.schema)
}).transform(({
  contents,
  ...rest
}) => ({
  ...rest,
  content: contents.map((it, index) => !it.text.trim() ? undefined : hyphenatableWordInput.postprocessSchemaInput(it, {
    taskId: rest.id,
    index
  })).filter(it => !!it)
}));

export { selectAnswersHyphenateWordsTaskSchema };
//# sourceMappingURL=_schema.js.map
